import { render } from "./SideBarMovilCliente.vue?vue&type=template&id=3dd10a70"
import script from "./SideBarMovilCliente.vue?vue&type=script&lang=js"
export * from "./SideBarMovilCliente.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__